document.addEventListener('DOMContentLoaded', ()=>{
    const button = document.getElementById('services-button');
    const menu = document.getElementById('services-menu');
    const container = document.getElementById('services-menu-container');
    button.addEventListener('click', (event)=>{
        event.stopPropagation(); // prevent immediate document click listener
        menu.classList.toggle('hidden');
    });
    // Close dropdown when clicking outside
    document.addEventListener('click', (event)=>{
        if (!container.contains(event.target)) menu.classList.add('hidden');
    });
});

//# sourceMappingURL=about-us.215a2c2a.js.map
